export default function(appName) {
  return appName?.toLowerCase() === 'openshift'
}
